module.exports = __webpack_public_path__ + "img/Restaurant1Phone.01d71d6b.png";